import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useRootStore } from 'stores/RootStore'
import { PaywallDrawer } from '../PaywallDrawer/PaywallDrawer'
import { useModals } from 'almanac-ui/Modal'
import { PaywallModal } from '../PaywallModal/PaywallModal'
import { useVirtualMarketerPlan } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/hooks/useVirtualMarketerPlan'
import { VirtualMarketerPlansModal } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/VirtualMarketerPlansModal/VirtualMarketerPlansModal'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { AutopilotPlansModal } from 'components/Settings/Workspace/AutopilotPlans/AutopilotPlansModal'
import { useCampaignsFeatureFlag } from 'hooks/useCampaignsFeatureFlag'
import { useShowCreditsPaywall } from 'hooks/useShowCreditsPaywall'
import { PurchaseContentCreditsModal } from 'components/Settings/TieredBilling/components/AutopilotDetails/components/PurchaseContentCreditsModal/PurchaseContentCreditsModal'
import { UpgradeForContentCreditsModal } from 'components/Settings/TieredBilling/components/AutopilotDetails/components/UpgradeForContentCreditsModal/UpgradeForContentCreditsModal'
import { useIsActiveOrCanceledPioneerPlan } from 'hooks/useIsActiveOrCanceledPioneerPlan'

export const usePaywall = () => {
  const isCampaignsEnabled = useCampaignsFeatureFlag()
  const { isMobile } = useResponsiveDesign()
  const { drawersStore, tierUsageStore } = useRootStore()
  const { openModal, closeAllModals } = useModals()
  const workspace = useCurrentWorkspace()
  const { data: virtualMarketerPlan } = useVirtualMarketerPlan()
  const { currentSubscription } = tierUsageStore
  const { showCreditsPaywall, price } = useShowCreditsPaywall()
  const isCanceledOrActivePioneerPlan = useIsActiveOrCanceledPioneerPlan()

  const openPaywall = () => {
    if (workspace?.is_virtual_marketer) {
      if (showCreditsPaywall && price && currentSubscription?.status === 'active') {
        openModal(PurchaseContentCreditsModal, { price })
        return
      }

      if (showCreditsPaywall && price && currentSubscription?.status === 'trialing') {
        openModal(UpgradeForContentCreditsModal)
        return
      }

      if (isCampaignsEnabled || isCanceledOrActivePioneerPlan) {
        openModal(AutopilotPlansModal)
        return
      }

      if (virtualMarketerPlan) {
        openModal(
          VirtualMarketerPlansModal,
          {
            plan: virtualMarketerPlan,
            onSuccess: () => {
              closeAllModals()
            },
          },
          { newStack: true },
        )
      }

      return
    }

    if (isMobile) {
      drawersStore.openDrawer(PaywallDrawer)
    } else {
      openModal(PaywallModal, {}, { newStack: true })
    }
  }

  return { openPaywall }
}
